import * as type from '../actions/types';

const initialState = {
    data: [],
    loading: false,
    error: null,
}

export default function availableProjectsData(state = initialState, action) {
    switch (action.type) {
        case type.SET_AVAILABLE_PROJECTS_DATA_REQUESTED:
            return {
                ...state,
                loading: true,
            }
        case type.SET_AVAILABLE_PROJECTS_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.data,
            }
        case type.SET_AVAILABLE_PROJECTS_DATA_FAILED:
            return {
                ...state,
                loading: false,
                error: action.message,
            }
        default:
            return state
    }
}